// extracted by mini-css-extract-plugin
export default {"divider":"Footer_divider__cAKa5","navbar":"Footer_navbar__gd5jo","copyright":"Footer_copyright__XN1Ks","nav-items":"Footer_nav-items__0MN+1","active":"Footer_active__9Q0CF"};